import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";
import { useState, useEffect, Fragment, useMemo, useCallback } from "react";
import { useFormContext, useWatch } from "react-hook-form";
// import dayjs from "dayjs";

import { useModal } from "hooks/use-modal";
import { useDisable } from "hooks/use-disable";
// import { useDeliveryTripListHeader } from "hooks/Sales/BillingNote/use-delivery-trip-list-header";

import {
  Box,
  // Grid,
  IconButton,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";

// import {
//   DragDropContext,
//   Draggable,
//   Droppable,
//   DropResult,
// } from "react-beautiful-dnd";
import Confirmation from "components/UI/Confirmation";
import ButtonLayout from "components/UI/ButtonLayout";
import { CustomizedBox } from "components/Custom/CustomizedBox";
import CustomizedButton from "components/Custom/CustomizedButton";
import ControlledTextField from "components/Controller/ControlledTextField";
// import ControlledNumberTextField from "components/Controller/ControlledNumberTextField";

// import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
// import LaunchOutlinedIcon from "@mui/icons-material/LaunchOutlined";

import { IBillingNote } from "types/Sales/billing-note";
// import { IDeliveryTripList } from "types/Sales/billing-note";

import { formatDate } from "utils/Date";
import { numberFormatter } from "utils/Formatter/Global";
import { typeValueFormatter } from "utils/Formatter/Logistic/Vehicle";
import { useDeliveryTripItemListContext } from "contexts/billing-note-context";
import { DELIVERY_TRIP_VIEW } from "services/AgGrid/DeliveryTripAgGrid";
import { GraphQLClient } from "graphql-request";
import { createGraphQLClientWithMiddleware } from "services/graphqlClient";
import CheckedDeliveryTripItemListModal from "components/UI/Modal/CheckedModal/CheckedDeliveryTripItemListModal";
import { useDeliveryTripItemListHeader } from "hooks/Sales/BillingNote/use-delivery-trip-item-list-header";
import dayjs from "dayjs";
import DeliveryTripIncomeRows from "./IncomeRow";
import LoadingAnimation from "components/Animation/Loading";
import TotalPreVatAmount from "./TotalPreVatAmount";

const DeliveryTripItemList = () => {
  const { t } = useTranslation();
  const {
    control,
    getValues,
    formState: { errors },
  } = useFormContext<IBillingNote>();
  const [disabled] = useDisable();
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const status = useWatch({ control, name: "aggrid_status" });
  const headers = useDeliveryTripItemListHeader(disabled, status);
  const graphQLClientWithHeaderDeliveryTrip: GraphQLClient =
    createGraphQLClientWithMiddleware("sales");

  const [openDeleteItemConfirmation, setOpenDeleteItemConfirmation] =
    useState<boolean>(false);
  const [deletedIndex, setDeletedIndex] = useState<number | undefined>(
    undefined,
  );

  const {
    modal: deliveryTripModal,
    openModalHandler: openDeliveryTripModalHandler,
    closeModalHandler: closeDeliveryTripModalHandler,
  } = useModal();

  const [deliveryTripIds, setDeliveryTripIds] = useState<string[]>([]);
  const [deliveryTripIdsSnapshot, setDeliveryTripIdsSnapshot] = useState<
    string[]
  >([]);

  const rowsPerPage = 50;

  // const watchCustomerUniqueId = useWatch({
  //   control,
  //   name: "customer_unique_id",
  // });

  const watchUniqueId = useWatch({
    control,
    name: "unique_id",
  });

  const { fields, controlledFields, remove, replace } =
    useDeliveryTripItemListContext();

  const deliverTripIds = useMemo(() => {
    return Array.from(
      new Set(
        fields.flatMap((f) => f.income_list.map((i) => i.income_unique_id)),
      ),
    );
  }, [fields]);

  useEffect(() => {
    setDeliveryTripIds(deliverTripIds);
    setDeliveryTripIdsSnapshot(deliverTripIds);
  }, [deliverTripIds]);

  const openDeleteItemConfirmationHandler = (index: number) => {
    setOpenDeleteItemConfirmation(true);
    setDeletedIndex(index);
  };

  const closeDeleteItemConfirmationHandler = () => {
    setOpenDeleteItemConfirmation(false);
    setDeletedIndex(undefined);
  };

  const deleteItemConfirmationAction = () => {
    if (deletedIndex || deletedIndex === 0) {
      remove(deletedIndex);
      setDeliveryTripIds((prev) =>
        prev.filter((_, index) => index !== deletedIndex),
      );
      setDeliveryTripIdsSnapshot((prev) =>
        prev.filter((_, index) => index !== deletedIndex),
      );
    }
    closeDeleteItemConfirmationHandler();
  };

  // const addDeliveryTripsHandler = (selectedDeliveryTrips: any[]) => {
  //   if (selectedDeliveryTrips?.length) {
  //     let filteredDeliveryTrips = fields.filter((dt) =>
  //       deliveryTripIds.includes(dt.income_unique_id),
  //     );
  //     // get current Items id to prevent duplication when appending newly selected Items
  //     const filteredDeliveryTripIds = filteredDeliveryTrips.map(
  //       (item) => item.income_unique_id,
  //     );
  //     selectedDeliveryTrips.forEach((dt) => {
  //       if (!filteredDeliveryTripIds.includes(dt.income_unique_id)) {
  //         filteredDeliveryTrips.push({
  //           ...dt,
  //         });
  //       }
  //     });
  //     // sort for proerly render order (and for role assignment when submitting)
  //     filteredDeliveryTrips = filteredDeliveryTrips.sort((a, b) => {
  //       return (
  //         deliveryTripIds.indexOf(a.income_unique_id) -
  //         deliveryTripIds.indexOf(b.income_unique_id)
  //       );
  //     });
  //     const mappedDeliveryTrips = filteredDeliveryTrips.map((item: any) => {
  //       if (filteredDeliveryTripIds.includes(item.income_unique_id)) {
  //         return item as IDeliveryTripItemList;
  //       }
  //       return {
  //         unique_id: uuidv4(),
  //         dt_unique_id: item.dt_unique_id,
  //         dt_job_no: item.dt_job_no,
  //         dt_issue_date: item.dt_issue_date,
  //         dt_vehicle_license_plate: item.dt_vehicle_license_plate,
  //         dt_vehicle_type: item.dt_vehicle_type,
  //         income_unique_id: item.income_unique_id,
  //         income_item_unique_id: item.income_item_unique_id,
  //         income_item_name: item.income_item_name,
  //         dt_customer_name: item.dt_customer_name,
  //         income_item_pre_vat_amount: item.income_item_pre_vat_amount,
  //       } as IDeliveryTripItemList;
  //     });
  //     replace(mappedDeliveryTrips);
  //   } else if (selectedDeliveryTrips.length === 0) {
  //     replace([]);
  //   }
  //   closeDeliveryTripModalHandler();
  // };

  const toTime = (d: any) => (dayjs(d).isValid() ? dayjs(d).valueOf() : 0);

  // const sortDT = (a: any, b: any) => {
  //   // 1. วันที่ออกเอกสาร DESC
  //   const dateDiff = toTime(b.dt_issue_date) - toTime(a.dt_issue_date);
  //   if (dateDiff !== 0) return dateDiff;

  //   // 2. เลขที่เอกสาร DESC
  //   return b.dt_unique_id.localeCompare(a.dt_unique_id, "th");
  // };

  // const sortIncome = (a: any, b: any) =>
  //   a.income_item_unique_id.localeCompare(b.income_item_unique_id);

  const addDeliveryTripsHandler = (
    selectedDeliveryTrips: any[],
    scopeIncomeIds?: Set<string>,
  ) => {
    // No scope = legacy full-replace path (e.g. clearing the list entirely).
    if (!scopeIncomeIds && !selectedDeliveryTrips.length) {
      replace([]);
      setPage(0);
      closeDeliveryTripModalHandler();
      return;
    }

    // 1. Snapshot existing fields so we can preserve user-edited data.
    const existingDtMap = new Map<string, any>();
    for (const dt of fields) {
      existingDtMap.set(dt.dt_unique_id, dt);
    }

    // 2. Start from existing DTs, but strip out income items that are within
    //    the current filter scope — they will be re-added from the selection.
    //    Items outside the scope are untouched (scope-aware merge).
    //
    //    NOTE: startTransition is intentionally NOT used here. In React 18's
    //    concurrent mode, wrapping replace() in startTransition causes fields
    //    (useFieldArray) and watchFieldArray (useWatch) to update in different
    //    render phases, producing a stale controlledFields mismatch that
    //    renders items out of order.
    const newDtMap = new Map<string, any>();

    if (scopeIncomeIds) {
      for (const dt of fields) {
        const outsideScopeIncomes = dt.income_list.filter(
          (i: any) => !scopeIncomeIds.has(i.income_unique_id),
        );
        if (outsideScopeIncomes.length > 0) {
          newDtMap.set(dt.dt_unique_id, {
            unique_id: dt.unique_id,
            dt_unique_id: dt.dt_unique_id,
            dt_job_no: dt.dt_job_no,
            dt_issue_date: dt.dt_issue_date,
            dt_vehicle_id: dt.dt_vehicle_id,
            dt_vehicle_license_plate: dt.dt_vehicle_license_plate,
            dt_vehicle_type: dt.dt_vehicle_type,
            dt_fuel_price: dt.dt_fuel_price, // 86d488a5h — already snapshot
            dt_customer_id: dt.dt_customer_id,
            dt_customer_name: dt.dt_customer_name,
            description: dt.description,
            income_list: outsideScopeIncomes.map((i: any) => ({
              income_unique_id: i.income_unique_id,
              income_item_unique_id: i.income_item_unique_id,
              income_item_name: i.income_item_name,
              income_item_pre_vat_amount: i.income_item_pre_vat_amount,
            })),
          });
        }
      }
    }

    // 3. Add selected items into the map.
    for (const item of selectedDeliveryTrips) {
      let dt = newDtMap.get(item.dt_unique_id);

      if (!dt) {
        const existing = existingDtMap.get(item.dt_unique_id);
        dt = {
          // Keep stable unique_id and user-written description when possible
          unique_id: existing?.unique_id ?? uuidv4(),
          dt_unique_id: item.dt_unique_id,
          dt_job_no: item.dt_job_no,
          dt_issue_date: item.dt_issue_date,
          dt_vehicle_id: item.dt_vehicle_id,
          dt_vehicle_license_plate: item.dt_vehicle_license_plate,
          dt_vehicle_type: item.dt_vehicle_type,
          // 86d488a5h — deliberately NOT `item.dt_fuel_price` like the lines
          // around it. `item` comes from the view and carries the trip's
          // price as of right now; re-opening the modal on a saved billing
          // note would overwrite the frozen snapshot with today's figure.
          // Prefer what is already on the document and only fall back to the
          // view for a trip being added for the first time (AC 9).
          // `dt_vehicle_type` above intentionally does refresh — the snapshot
          // rule applies to the price, not to every dt_ field.
          dt_fuel_price: existing?.dt_fuel_price ?? item.dt_fuel_price,
          dt_customer_id: item.dt_customer_id,
          dt_customer_name: item.dt_customer_name,
          description: existing?.description ?? item.dt_work_list ?? "",
          income_list: [],
        };
        newDtMap.set(item.dt_unique_id, dt);
      }

      // build income index once per DT
      if (!dt._incomeIndex) {
        dt._incomeIndex = new Set(
          dt.income_list.map((i: any) => i.income_unique_id),
        );
      }

      if (!dt._incomeIndex.has(item.income_unique_id)) {
        dt._incomeIndex.add(item.income_unique_id);

        // Preserve existing pre-vat amount if it was already in the form
        const existingIncome = existingDtMap
          .get(item.dt_unique_id)
          ?.income_list?.find(
            (i: any) => i.income_unique_id === item.income_unique_id,
          );

        dt.income_list.push({
          income_unique_id: item.income_unique_id,
          income_item_unique_id: item.income_item_unique_id,
          income_item_name: item.income_item_name,
          income_item_pre_vat_amount:
            existingIncome?.income_item_pre_vat_amount ??
            item.income_item_pre_vat_amount ??
            0,
        });
      }
    }

    // 4. cleanup + sort
    const result = Array.from(newDtMap.values()).map((dt) => {
      delete dt._incomeIndex;

      dt.income_list.sort((a: any, b: any) =>
        (a.income_item_unique_id ?? "").localeCompare(
          b.income_item_unique_id ?? "",
        ),
      );

      return dt;
    });

    result.sort((a, b) => {
      const dateDiff = toTime(b.dt_issue_date) - toTime(a.dt_issue_date);

      if (dateDiff !== 0) return dateDiff;

      return b.dt_unique_id.localeCompare(a.dt_unique_id, "th");
    });

    replace(result);
    setPage(0);

    closeDeliveryTripModalHandler();
  };

  const openDTfromUniqueId = async (dt_reference_unique_id: string) => {
    try {
      const { DeliveryTripViewAggrid } =
        await graphQLClientWithHeaderDeliveryTrip.request(DELIVERY_TRIP_VIEW, {
          aggridInput: {
            startRow: 0,
            endRow: 1,
            filterModel: {
              unique_id: {
                filter: dt_reference_unique_id,
                filterType: "text",
                type: "equals",
              },
            },
          },
        });

      window.open(
        `/logistic/delivery-trip/${DeliveryTripViewAggrid.results[0].id}`,
        "_blank",
      );
    } catch (error) {}
  };

  //   const isAllSelected =
  //     deliveryTripIdsSnapshot.length > 0 &&
  //     deliveryTripIds.length === deliveryTripIdsSnapshot.length;

  //   const isIndeterminate =
  //     deliveryTripIds.length > 0 &&
  //     deliveryTripIds.length < deliveryTripIdsSnapshot.length;

  //     useEffect(() => {

  //     }, [])

  const visibleRows = useMemo(() => {
    const start = page * rowsPerPage;
    const end = start + rowsPerPage;
    // Use getValues() (reads form store synchronously) instead of controlledFields
    // from context. After replace(), watchFieldArray in the context can lag by one
    // render and its spread overwrites the correct new fields data with stale data.
    const allValues = getValues("delivery_trip_item_list") ?? [];

    return fields.slice(start, end).map((field, i) => {
      const formIndex = start + i;
      return {
        ...allValues[formIndex],
        id: field.id,
        formIndex,
      };
    });
  }, [fields, getValues, page, rowsPerPage]);

  const handleRemoveDT = useCallback(
    (dtIndex: number) => {
      remove(dtIndex);
    },
    [remove],
  );

  // if (isLoading) {
  //   return <LoadingAnimation />;
  // }

  return (
    <CustomizedBox
      sx={{ breakAfter: "auto" }}
      margin="1rem 0 0 0"
      maxWidth={1650}
    >
      <Box display="flex" alignItems="center" mb={2}>
        <Typography fontWeight={600}>การจัดส่ง</Typography>
      </Box>
      {isLoading && <LoadingAnimation />}
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="delivery trip item table">
          {/* ================= HEADER ================= */}
          <TableHead>
            <TableRow>
              {headers.map((header, index) => (
                <TableCell
                  key={index}
                  align="center"
                  sx={{
                    px: 1,
                    py: 1.5,
                    backgroundColor: "secondary.main",
                    width: header.width,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: 0.5,
                      justifyContent: header.align ?? "center",
                      alignItems: "center",
                    }}
                  >
                    <Typography fontSize={14} fontWeight={600}>
                      {header.thaiLabel}
                    </Typography>
                    {header.required && (
                      <Typography
                        fontSize={14}
                        color="error.main"
                        fontWeight={600}
                      >
                        *
                      </Typography>
                    )}
                  </Box>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          {/* ================= BODY ================= */}
          <TableBody>
            {visibleRows.map((field) => {
              const totalColumns = headers.length;
              const showActionColumn =
                [
                  null,
                  undefined,
                  "",
                  "draft",
                  "cancelled",
                  "wait_payment",
                ].includes(status as any) && !disabled;

              return (
                <Fragment key={field.unique_id}>
                  {/* ===== Main data row ===== */}
                  <TableRow
                    sx={{
                      breakInside: "avoid",
                      "& > td": {
                        borderBottom: "none", // ✅ remove inner divider
                      },
                    }}
                  >
                    {/* index */}
                    <TableCell
                      align="center"
                      width={headers[0]?.width}
                      sx={{ px: 1, py: 1 }}
                    >
                      <Typography fontSize={14}>
                        {field.formIndex + 1}
                      </Typography>
                    </TableCell>

                    {/* document no */}
                    <TableCell width={headers[1]?.width}>
                      <Link
                        component="button"
                        underline="none"
                        fontSize={14}
                        onClick={() => openDTfromUniqueId(field.dt_unique_id)}
                      >
                        {field.dt_unique_id}
                      </Link>
                    </TableCell>

                    {/* job_no */}
                    <TableCell width={headers[2]?.width}>
                      <Typography fontSize={14}>{field.dt_job_no}</Typography>
                    </TableCell>

                    {/* issue date */}
                    <TableCell width={headers[3]?.width}>
                      <Typography fontSize={14}>
                        {formatDate(field.dt_issue_date)}
                      </Typography>
                    </TableCell>

                    {/* license plate */}
                    <TableCell width={headers[4]?.width}>
                      <Typography fontSize={14}>
                        {field.dt_vehicle_license_plate}
                      </Typography>
                    </TableCell>

                    {/* vehicle type */}
                    <TableCell width={headers[5]?.width}>
                      <Typography fontSize={14}>
                        {typeValueFormatter(field.dt_vehicle_type ?? "")}
                      </Typography>
                    </TableCell>

                    {/* 86d488a5h — fuel price, snapshot from the trip when it
                        was added to this billing note. Read-only in every
                        status: it is a billing reference, not an input.
                        Guarded by hand because numberFormatter(undefined)
                        renders "0.00", and "no price recorded" must not read
                        as a price of zero. */}
                    <TableCell align="right" width={headers[6]?.width}>
                      <Typography fontSize={14}>
                        {field.dt_fuel_price === null ||
                        field.dt_fuel_price === undefined
                          ? "-"
                          : numberFormatter(field.dt_fuel_price)}
                      </Typography>
                    </TableCell>

                    {/* item code */}
                    <TableCell width={headers[7]?.width}>
                      {/* <Typography fontSize={14}>
                        {field.income_item_unique_id}
                      </Typography> */}
                    </TableCell>

                    {/* item Name */}
                    <TableCell width={headers[8]?.width}>
                      {/* <Typography fontSize={14}>
                        {field.income_item_name}
                      </Typography> */}
                    </TableCell>

                    {/* amount */}
                    <TableCell
                      align="right"
                      width={headers[9]?.width}
                      sx={{
                        "& .MuiBox-root": {
                          mr: disabled ? "1rem" : 0,
                        },
                      }}
                    >
                      {/* <ControlledNumberTextField
                        fullWidth
                        control={control}
                        name={`delivery_trip_item_list.${field.formIndex}.income_item_pre_vat_amount`}
                        error={Boolean(
                          errors?.delivery_trip_item_list?.[field.formIndex]
                            ?.income_item_pre_vat_amount,
                        )}
                        helperText={
                          errors?.delivery_trip_item_list?.[field.formIndex]
                            ?.income_item_pre_vat_amount?.message
                        }
                        viewMode={disabled}
                      /> */}
                    </TableCell>

                    {/* action */}
                    {showActionColumn && (
                      <TableCell
                        align="center"
                        width={headers[10]?.width}
                        sx={{ px: 1, py: 1 }}
                      >
                        <IconButton
                          size="small"
                          sx={{ color: "rgba(0,0,0,0.54)" }}
                          onClick={() =>
                            openDeleteItemConfirmationHandler(field.formIndex)
                          }
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    )}
                  </TableRow>
                  <DeliveryTripIncomeRows
                    key={field.id}
                    control={control}
                    disabled={disabled}
                    dtIndex={field.formIndex}
                    headers={headers}
                    onEmpty={() => handleRemoveDT(field.formIndex)}
                    onRemoveIncome={(incomeId) => {
                      setDeliveryTripIds((prev) =>
                        prev.filter((id) => id !== incomeId),
                      );
                    }}
                  />
                  {/* ===== Description row ===== */}
                  <TableRow
                    sx={{
                      breakInside: "avoid",
                    }}
                  >
                    {/* empty index column */}
                    <TableCell />

                    {/* description */}
                    <TableCell
                      colSpan={
                        showActionColumn ? totalColumns - 2 : totalColumns
                      }
                      sx={{
                        borderBottom: "1px solid #E0E0E0", // ✅ single divider per item
                        pt: 0,
                        pb: 1.5,
                      }}
                    >
                      {disabled ? (
                        <Typography
                          fontSize={14}
                          sx={{ ml: 0.5, color: "#737373" }}
                        >
                          {field.description || "-"}
                        </Typography>
                      ) : (
                        <ControlledTextField
                          name={`delivery_trip_item_list.${field.formIndex}.description`}
                          control={control}
                          label={t("sentence.detail")}
                          error={Boolean(
                            errors?.delivery_trip_item_list?.[field.formIndex]
                              ?.description,
                          )}
                          helperText={
                            errors?.delivery_trip_item_list?.[field.formIndex]
                              ?.description?.message
                          }
                        />
                      )}
                    </TableCell>

                    {/* empty action column */}
                    {showActionColumn && <TableCell />}
                  </TableRow>
                </Fragment>
              );
            })}
          </TableBody>
        </Table>
        <Box
          sx={{
            position: "sticky",
            left: 0,
            bottom: 0,
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            p: 1,
          }}
        >
          <TablePagination
            component="div"
            count={fields.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(_, p) => {
              setPage(p);
              // setIsLoading(true);
              // startTransition(() => {
              //   setPage(p);
              //   setIsLoading(false);
              // });
            }}
            rowsPerPageOptions={[rowsPerPage]}
          />
        </Box>
      </TableContainer>
      {!disabled && (
        <ButtonLayout sx={{ marginTop: 2 }}>
          <CustomizedButton
            title={`${t("button.add")}${t("logistic.delivery_trip.index")}`}
            variant="outlined"
            onClick={openDeliveryTripModalHandler}
            startAddIcon
            // disabled={!watchCustomerUniqueId}
          />
        </ButtonLayout>
      )}
      <TotalPreVatAmount controlledFields={controlledFields} />
      <Confirmation
        title="ยืนยันการลบใบงานจัดส่ง"
        open={openDeleteItemConfirmation}
        handleClose={closeDeleteItemConfirmationHandler}
        action={deleteItemConfirmationAction}
      />
      <CheckedDeliveryTripItemListModal
        showSelectDeliveryTripItemList={deliveryTripModal}
        deliveryTripItemListIds={deliveryTripIds}
        setDeliveryTripItemListIds={setDeliveryTripIds}
        deliveryTripItemListIdsSnapshot={deliveryTripIdsSnapshot}
        setDeliveryTripItemListIdsSnapshot={setDeliveryTripIdsSnapshot}
        rowSelection="multiple"
        closeDeliveryTripItemListTable={closeDeliveryTripModalHandler}
        addDeliveryTripsItemListHandler={addDeliveryTripsHandler}
        // customerUniqueId={watchCustomerUniqueId}
        billingNoteUniqueId={watchUniqueId}
        // isAllSelected={isAllSelected}
        // isIndeterminate={isIndeterminate}
      />
    </CustomizedBox>
  );
};

export default DeliveryTripItemList;
